import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { WordPopLogo } from "@/components/ui/WordPopLogo";

interface AuthGateModalProps {
  isOpen: boolean;
  onContinueAsGuest: () => void;
}

export const AuthGateModal = ({ isOpen, onContinueAsGuest }: AuthGateModalProps) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" role="dialog" aria-modal="true" aria-labelledby="auth-gate-title" aria-describedby="auth-gate-description">
      {/* Backdrop with blur */}
      <div className="absolute inset-0 bg-background/80 backdrop-blur-md" />
      
      {/* Modal Card */}
      <div className="relative z-10 w-full max-w-md mx-4 animate-fade-in">
        <div className="bg-card border border-border rounded-lg shadow-lg p-8 space-y-6">
          {/* Logo/Title */}
          <div className="text-center space-y-2">
          <h1 id="auth-gate-title" className="text-4xl font-bold tracking-tight text-foreground">
              <WordPopLogo linkTo={null} size="lg" />
              <span className="sr-only">WordPop</span>
            </h1>
            <p className="text-sm text-muted-foreground">
              Daily Word Puzzle Game
            </p>
          </div>

          {/* Description */}
          <div id="auth-gate-description" className="text-center space-y-2">
            <p className="text-base text-foreground">
              Sign in to sync progress across devices
            </p>
            <p className="text-sm text-muted-foreground">
              Track your stats, streaks, and play on any device
            </p>
          </div>

          {/* Buttons */}
          <div className="space-y-3">
            {/* Primary: Sign In */}
            <Button
              onClick={() => navigate("/auth")}
              className="w-full"
              size="lg"
              aria-label="Sign in or create a new WordPop account"
            >
              Sign In or Create Account
            </Button>

            {/* Secondary: Guest */}
            <Button
              onClick={onContinueAsGuest}
              variant="outline"
              className="w-full"
              size="lg"
              aria-label="Continue playing WordPop as a guest"
            >
              Continue as Guest
            </Button>
          </div>

          {/* Fine print */}
          <p className="text-xs text-center text-muted-foreground">
            Guest mode saves progress locally only. 📱 Install WordPop for offline play!
          </p>
        </div>
      </div>
    </div>
  );
};
